module.exports = __webpack_public_path__ + "static/media/bonusSpins_7_10.727f42a1.png";